// extracted by mini-css-extract-plugin
export default {"editor":"RichEditor_editor__LF7pw","editorCounter":"RichEditor_editorCounter__e3SsY"};